export interface CommissionDTO {
  id: number;
  beneficiary_user_id: number;
  beneficiary_nickname: string;
  source_user_id: number;
  source_nickname: string;
  reward_order_id: number;
  level: number;
  type: CommissionType;
  amount_fen: number;
  amount_yuan: string;
  status: CommissionStatus;
  created_at: string;
  settled_at?: string;
}

export interface CommissionListResponseDTO {
  total: number;
  page: number;
  page_size: number;
  items: CommissionDTO[];
}

export type CommissionStatus = 'pending' | 'settled' | 'cancelled';
export type CommissionType = 'fixed' | 'percentage';
export type CommissionRange = '' | '7d' | 'month';

export const COMMISSION_STATUS_LABELS: Record<CommissionStatus, string> = {
  pending: '待结算',
  settled: '已结算',
  cancelled: '已取消',
};

export const ALL_COMMISSION_STATUSES: CommissionStatus[] = ['pending', 'settled', 'cancelled'];

export const COMMISSION_TYPE_LABELS: Record<CommissionType, string> = {
  fixed: '邀请固定奖励',
  percentage: '任务返佣',
};

export const ALL_COMMISSION_TYPES: CommissionType[] = ['fixed', 'percentage'];

export const ALL_COMMISSION_LEVELS = [1, 2, 3] as const;

export const COMMISSION_LEVEL_LABELS: Record<number, string> = {
  1: '一级邀请',
  2: '二级邀请',
  3: '三级邀请',
};

export const COMMISSION_RANGE_LABELS: Record<CommissionRange, string> = {
  '': '全部时间',
  '7d': '近7天',
  month: '本月',
};

export const ALL_COMMISSION_RANGES: CommissionRange[] = ['', '7d', 'month'];
